var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgHardwareRes = function SvgHardwareRes(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#DFE4EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.354 3h.292A2.357 2.357 0 0 1 38 5.354v.292A2.357 2.357 0 0 1 35.646 8h-.292A2.357 2.357 0 0 1 33 5.646v-.292A2.357 2.357 0 0 1 35.354 3Z",
    fill: "#FEDA01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H5v3h23V4Z",
    fill: "#C7CED9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.354 3h.292A2.357 2.357 0 0 1 45 5.354v.292A2.357 2.357 0 0 1 42.646 8h-.292A2.357 2.357 0 0 1 40 5.646v-.292A2.35 2.35 0 0 1 42.354 3Z",
    fill: "#345795"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19h36a2 2 0 1 0 0-4H7a2 2 0 1 0 0 4Z",
    fill: "#C7CED9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#345795"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30h36a2 2 0 1 0 0-4H7a2 2 0 1 0 0 4Z",
    fill: "#C7CED9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#5A9DFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 41.001h36a2 2 0 0 0 0-4H7a2 2 0 1 0 0 4Z",
    fill: "#C7CED9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 43.001a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#FEDA01"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 60C54.404 60 60 54.404 60 47.5S54.404 35 47.5 35 35 40.596 35 47.5 40.596 60 47.5 60Z",
    fill: "#5A9DFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 44.355 46.347 52 41 46.655l1.354-1.354 3.993 3.991 6.3-6.292L54 44.355Z",
    fill: "#fff"
  })));
};

export default SvgHardwareRes;